{
  "CONTACTS_FILTER": {
    "TITLE": "Filtrovať kontakty",
    "SUBTITLE": "Pridajte filtre nižšie a kliknite na 'Odoslať' na filtrovanie kontaktov.",
    "EDIT_CUSTOM_SEGMENT": "Upraviť segment",
    "CUSTOM_VIEWS_SUBTITLE": "Pridajte alebo odstráňte filtre a aktualizujte svoj segment.",
    "ADD_NEW_FILTER": "Pridať filter",
    "CLEAR_ALL_FILTERS": "Vymazať všetky filtre",
    "FILTER_DELETE_ERROR": "Na uloženie je potrebný aspoň jeden filter",
    "SUBMIT_BUTTON_LABEL": "Odoslať",
    "UPDATE_BUTTON_LABEL": "Aktualizovať segment",
    "CANCEL_BUTTON_LABEL": "Zrušiť",
    "CLEAR_BUTTON_LABEL": "Vymazať filtre",
    "EMPTY_VALUE_ERROR": "Hodnota je povinná",
    "SEGMENT_LABEL": "Názov segmentu",
    "SEGMENT_QUERY_LABEL": "Dopyt segmentu",
    "TOOLTIP_LABEL": "Filtrovať kontakty",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "AND",
      "OR": "OR"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Rovná sa",
      "not_equal_to": "Nerovná sa",
      "contains": "Obsahuje",
      "does_not_contain": "Neobsahuje",
      "is_present": "Je prítomné",
      "is_not_present": "Nie je prítomné",
      "is_greater_than": "Je väčšie ako",
      "is_lesser_than": "Je menšie ako",
      "is_greater_than_or_equal": "Je väčšie alebo rovné",
      "is_less_than_or_equal": "Je menšie alebo rovné",
      "newer_than_days": "Je novšie ako x dní (vrátane)",
      "older_than_days": "Je staršie ako x dní (vrátane)"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Hodnota je povinná"
    },
    "ATTRIBUTES": {
      "NAME": "Meno",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Telefónne číslo",
      "IDENTIFIER": "Identifikátor",
      "CITY": "Mesto",
      "COUNTRY": "Krajina",
      "CUSTOM_ATTRIBUTE_LIST": "Zoznam",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Číslo",
      "CUSTOM_ATTRIBUTE_LINK": "Odkaz",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Zaškrtávacie pole",
      "CREATED_AT": "Vytvorené",
      "LAST_ACTIVITY": "Posledná aktivita",
      "REFERER_LINK": "Odkazujúci odkaz",
      "BLOCKED": "Zablokované"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Štandardné filtre",
      "ADDITIONAL_FILTERS": "Ďalšie filtre",
      "CUSTOM_ATTRIBUTES": "Vlastné atribúty"
    }
  }
}
